import React, { useState, useContext, useEffect, useRef } from 'react';
import { Button, Input } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { designActions } from '../../../actions';
import { DesignContext } from '../../../containers/GraphicBuilder/GraphicBuilder';
import InputRange from 'react-hgs-input-range';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import './Toolbar.css';
import 'react-hgs-input-range/lib/css/index.css';

const VideoToolbar = props => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { activePageRef, activeTrimRef, activeVolumeRef } = useContext(DesignContext);
  const selectedEntity = useSelector(state => state.design.selectedEntity);
  // const entity = useSelector(state => state.design.entitiesState[selectedEntity.id]);
  let entity;
  let videoSrc;
  const entityInBg = useSelector(state => state.design.pages[activePageRef.current].background);
  const entityById = useSelector(state => state.design.entitiesState[selectedEntity.id]);
  if (selectedEntity.id === -1) {
    entity = _.get(entityInBg, 'media');
    videoSrc = _.get(entity, 'src');
  } else {
    entity = entityById;
    if (entity.type === 'Video') {
      videoSrc = entity.src;
    } else if (entity.type === 'Frame') {
      videoSrc = entity.data.medias.frame.src;
    }
  }
  const [trimmer, setTrimmer] = useState(false);
  const [volume, setVolume] = useState(entity && entity.data ? entity.data.volume * 100 : 100);
  const [soundBox, setSoundBox] = useState(false);
  const [activeTrim, setActiveTrim] = useState({});
  const trimRef = useRef();
  const observerRef = useRef();
  const lCoverRef = useRef();
  const rCoverRef = useRef();
  trimRef.current = activeTrim;

  const saveTrim = () => {
    const data = {
      trim: trimRef.current,
    };

    dispatch(designActions.changeEntityData(activePageRef.current, selectedEntity.id, data));
  };

  useEffect(() => {
    const entityTrim = _.get(entity, 'data.trim', 0);
    setActiveTrim(entityTrim);
    activeTrimRef.current = entityTrim;
    activeVolumeRef.current = _.get(entity, 'data.volume', 1);

    if (trimmer && videoSrc) {
      const mainBg = document.querySelector('.trimBox .input-range__track--background');
      const activeBg = document.querySelector('.trimBox .input-range__track--active');
      if (!mainBg || !activeBg) return undefined;

      if (!lCoverRef.current) lCoverRef.current = document.createElement('div');
      if (!rCoverRef.current) rCoverRef.current = document.createElement('div');
      const lCover = lCoverRef.current;
      const rCover = rCoverRef.current;
      const videoPoster = videoSrc.replace('screen', 'frame');
      mainBg.appendChild(lCover);
      mainBg.appendChild(rCover);
      lCover.classList.add('lCover');
      rCover.classList.add('rCover');
      mainBg.style.backgroundImage = `url('${videoPoster}')`;
      observerRef.current = new MutationObserver(mutations => {
        mutations.forEach(mutationRecord => {
          const width = parseFloat(mutationRecord.target.style.width);
          const left = parseFloat(mutationRecord.target.style.left);
          lCover.style.width = left + '%';
          rCover.style.width = 100 - width - left + '%';
        });
      });
      observerRef.current.observe(activeBg, { attributes: true, attributeFilter: ['style'] });
      let activeWidth = parseFloat(activeBg.style.width);
      let activeLeft = parseFloat(activeBg.style.left);
      lCover.style.width = activeLeft + '%';
      rCover.style.width = 100 - activeWidth - activeLeft + '%';
    }

    return () => {
      if (observerRef.current) observerRef.current.disconnect();
    };
  }, [activeTrimRef, activeVolumeRef, entity, selectedEntity.id, trimmer, videoSrc]);

  const handleChange = (e, { name, value }) => {
    // target.style.opacity = value / 100;
    setVolume(value);
    activeVolumeRef.current = value;
  };

  const mouseUpHandler = () => {
    const data = {
      volume: volume / 100,
    };

    dispatch(designActions.changeEntityData(activePageRef.current, selectedEntity.id, data));
  };

  const useOutsideClick = ref => {
    const handleClickOutside = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        if (soundBox) {
          setSoundBox(false);
        }
      }
    };

    useEffect(() => {
      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        // Unbind the event listener on  clean up
        document.removeEventListener('mousedown', handleClickOutside);
      };
    });
  };

  const wrapperRef = useRef(null);
  useOutsideClick(wrapperRef);

  return (
    <div className="videoToolbar">
      <Button className="button text" title="Trimmer" onMouseDown={() => setTrimmer(true)}>
        <span>{t('trim')}</span>
      </Button>
      <Button className="button text" title="Sound" onMouseDown={() => setSoundBox(true)}>
        <span>{t('sound')}</span>
      </Button>
      {trimmer && (
        <div className="trimBox">
          <Button
            className="button text left"
            title="Trimmer"
            onMouseDown={() => setTrimmer(false)}
          >
            <span>{t('close')}</span>
          </Button>
          <InputRange
            style={{ backgroundColor: '#000' }}
            draggableTrack
            maxValue={entity.data.duration}
            minValue={0}
            step={0.1}
            value={activeTrim}
            onChange={value => {
              // setGlobalTrim(value);
              activeTrimRef.current = value;
              setActiveTrim(value);
            }}
            onChangeComplete={() => saveTrim()}
          />
          {/* <Button
            className="button text right"
            title="Trimmer"
            onMouseDown={() => setTrimmer(false)}
          >
            <span>{text.accept}</span>
          </Button> */}
        </div>
      )}
      {soundBox && (
        <div className="sliderBox" ref={wrapperRef}>
          <Input
            label={volume}
            min={0}
            max={100}
            name="duration"
            onChange={handleChange}
            onMouseUp={mouseUpHandler}
            step={1}
            type="range"
            value={volume}
          />
        </div>
      )}
    </div>
  );
};

export default VideoToolbar;
